import * as constants from '../constants';

const initialState = {
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getReview.success:
        case constants.updateReview.success:
        case constants.addReview.success: {
            return action.payload;
        }

        case constants.clearReview.toString(): {
            return initialState;
        }

        default:
            return state;
    }
}
